export default __webpack_public_path__ + "static/media/daikin.9635d2c2.png";